import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RoleService, Role } from '@perval/shared';
import {
  SharedStateLegacyService,
  StateKey,
} from '../../../shared/services/stockage/shared-state-legacy.service';
import { Tarif } from '../../models/tarif';
import { GrilleTarifaireService } from '../../services/grille-tarifaire.service';

@Component({
  selector: 'app-commande-credits-container',
  templateUrl: './commande-credits.container.html',
  styleUrls: ['./commande-credits.container.scss'],
})
export class CommandeCreditsContainer implements OnInit {
  tarifs: Tarif[] = [];

  constructor(
    private readonly roleService: RoleService,
    private readonly sharedStateLegacyService: SharedStateLegacyService,
    private readonly grilleTarifaireService: GrilleTarifaireService,
    private readonly titleService: Title,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    this.titleService.setTitle('Commande de crédits | Perval.fr');

    this.tarifs =
      await this.grilleTarifaireService.getGrilleTarifaireServices();
  }

  get isNotaire(): boolean {
    return this.roleService.currentUserRoles.includes(Role.NOTARY);
  }

  get isRenouvellement(): boolean {
    return (
      this.sharedStateLegacyService.getItem(StateKey.renouvellement) === 'true'
    );
  }
}
